/**
* Event Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Event Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'event-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      eventsSlider();

      $( window ).on( 'resize', function() {
        eventsSlider();
      } );
      function eventsSlider() {
        $( '.event-slider' ).each( function() {
          const $progressBarLabel = $( this ).find( '.slider__label' );
          const $progressBar = $( this ).find( '#progress-bar' );
          $( this ).find( '.events-slider' ).on( 'init', function( event, slick, currentSlide, nextSlide ) {
            $progressBar
                .css( 'background-size', 5 + '% 100%' )
                .attr( 'aria-valuenow', 5 );
            $progressBarLabel.text( 5 + '% completed' );
          } );
          $( this ).find( '.events-slider' ).on( 'beforeChange', function( event, slick, currentSlide, nextSlide ) {
            let calc = ( ( nextSlide ) / ( slick.slideCount - 1 ) ) * 100;
            if ( calc === 0 ) {
              calc = 5;
            }
            $progressBar
                .css( 'background-size', calc + '% 100%' )
                .attr( 'aria-valuenow', calc );
            $progressBarLabel.text( calc + '% completed' );
          } );
          if ( $( this ).find( '.event-slide' ).length > 1 ) {
            const heights = $( this ).find( '.event-slide' ).map( function() {
              return $( this ).height();
            } );
            const maxHeight = Math.max.apply( null, heights );
            $( this ).find( '.event-slide' ).height( maxHeight );
            $( this ).find( '.events-slider' ).slick( {
              dots: false,
              arrows: true,
              prevArrow: $( this ).find( '.prev-slide' )[0],
              nextArrow: $( this ).find( '.next-slide' )[0],
              slidesToShow: 1,
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 1,
                  },
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                  },
                },
              ],
            } );
          } else {
            if ( window.innerWidth < 1024 ) {
              $( this ).find( '.events-slider' ).slick( {
                dots: false,
                arrows: true,
                prevArrow: $( this ).find( '.prev-slide' )[0],
                nextArrow: $( this ).find( '.next-slide' )[0],
                slidesToShow: 1,
              } );

              $( this ).find( '.slider-buttons' ).removeClass( 'hidden' ).addClass( 'flex' );
            } else {
              $( this ).find( '.slider.slick-slider' ).slick( 'unslick' );
              $( this ).find( '.slider-buttons' ).addClass( 'hidden' ).removeClass( 'flex' );
            }
          }
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'event-slider', COMPONENT );
} )( app );
